import React from 'react';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { trackCallConversion } from '../../utils/tracking';
import './FloatingContact.css';

export default function FloatingContact() {
  return (
    <div className="floating-contact-wrapper" aria-label="Quick Contact Actions">
      {/* Direct Call Button */}
      <a 
        href="tel:+918700319769" 
        className="floating-btn call-btn"
        aria-label="Call Us Directly"
        title="Call +91 8700319769"
        data-dsmr-phone="true"
        onClick={(e) => trackCallConversion(e, "tel:+918700319769")}
      >
        <div className="btn-icon">
          <Phone size={22} />
        </div>
        <span className="btn-tooltip">Call Support</span>
      </a>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/918700319769?text=Hello%20DSMR%20Solutions%2C%20I%20need%20assistance%20with%20device%20repair." 
        target="_blank" 
        rel="noopener noreferrer" 
        className="floating-btn whatsapp-btn"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
      >
        <div className="btn-icon">
          <FaWhatsapp size={26} />
        </div>
        <span className="pulse-ring"></span>
        <span className="btn-tooltip">Chat on WhatsApp</span>
      </a>
    </div>
  );
}
